module.exports = __webpack_public_path__ + "static/img/illust_5_mk.13cea3ad.svg";